import { create } from "../../../../../common/utils/zustand_state_manager";
import { ChecklistServicoDropDown } from "../../../domain/models/checklist_servico_dropdown";

/**
 * useObrasChecklistareaFilters
 */

type State = {
  statusChecklist: number;
  statusVerificacao: number;
  checklistServicoDropdown: ChecklistServicoDropDown[] | undefined;
};

type Actions = {};

export const useObrasChecklistareaFilters = create<State & Actions>((set) => ({
  statusChecklist: 2,
  statusVerificacao: 3,
  checklistServicoDropdown: undefined,
}));